export default {
      id: "logo-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#logo",
      toString: function () {
        return this.url;
      }
    }